export function isValidLastName(name) {
  return name ? (name.length > 0 || "Last name is required") : "Last name is required"
}

export const rules = [isValidLastName]
